function DualistPlaceholder() {
    return (
        <div className="grid grid-cols-7 grid-col-dense gap-10">
            <div className={"grid grid-flow-row gap-4 transition-all overflow-x-hidden overflow-y-auto col-span-3"}>
                <div className={"animate-pulse px-4 py-3 h-5 bg-blue-gray-200 rounded-lg w-1/2"}/>
                <div className={"animate-pulse px-4 py-3 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className={"animate-pulse px-4 py-3 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className={"animate-pulse px-4 py-3 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className={"animate-pulse px-4 py-3 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className="grid grid-flow-col justify-between">
                    <div className={"animate-pulse px-4 py-3 h-3 bg-blue-gray-200 rounded-lg w-16"}/>
                    <div className={"animate-pulse px-4 py-3 gap-2 h-3 bg-blue-gray-200 rounded-lg w-16"}/>
                </div>
            </div>
            <div className={"justify-center items-center flex col-span-1"}>
                <div className={"animate-pulse h-12 w-12 bg-blue-gray-200 rounded-full"}/>
            </div>
            <div className={"grid grid-flow-row gap-4 transition-all overflow-x-hidden overflow-y-auto col-span-3"}>
                <div className={"animate-pulse px-4 py-3 gap-2 h-5 bg-blue-gray-200 rounded-lg w-1/3"}/>
                <div className={"animate-pulse px-4 py-3 gap-2 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className={"animate-pulse px-4 py-3 gap-2 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className={"animate-pulse px-4 py-3 gap-2 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className={"animate-pulse px-4 py-3 gap-2 h-20 bg-blue-gray-200 rounded-lg"}/>
                <div className="grid grid-flow-col justify-between">
                    <div className={"animate-pulse px-4 py-3 h-3 bg-blue-gray-200 rounded-lg w-16"}/>
                    <div className={"animate-pulse px-4 py-3 h-3 bg-blue-gray-200 rounded-lg w-16"}/>
                </div>
            </div>
        </div>
    );
}

export default DualistPlaceholder;
